export default function couponsReducer(state=null, action) {
  switch (action.type) {
    case 'coupons/load':
      return action.coupons;
    case 'coupon/load':
      return _.uniqBy([action.coupon, ...(state || [])], 'id');
    default:
      return state;
  }
}
